import Gobalstore from "../index";
export const actions = {
  getSummaryEntreaty: function (localStore, year) {
    return this.axios({
      method: "GET",
      url: `/admin/guarded/main/reporting/ent-stages?year=${year}`,
    }).then(function (response) {
      localStore.commit("setReporting", response.data);
      return response;
    });
  },

  getInvoiceGraph: function (localStore, year) {
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/reporting/invoice-graph?year=${year}`,
    }).then(function (response) {
      localStore.commit("setGraph", response.data);
    });
  },
};
